import { isEmpty } from 'lodash';
import moment from 'moment';
import { Clock, MapPin, Menu, Settings } from 'react-feather';
import { FormattedMessage, useIntl } from 'react-intl';
import SlidingPane from 'react-sliding-pane';
import { Badge, Col, Label, Media, Row, UncontrolledTooltip } from 'reactstrap';
import Icon from 'utility/icomoon';
import { GetMainStateById, GetMainStateName, GetMainStateStyle } from 'views/screens/Units/utils';
import MediaGallery from '../../../../../components/MediaGallery';
import { env } from '@src/env';

interface Props {
  unit: any;
  isSlidingPaneOpen: boolean;
  closeSlidingPane?: any;
}

const SlidingPaneSharedLinkUnitInformation = (props: Props) => {
  const { unit, isSlidingPaneOpen, closeSlidingPane } = props;
  const intl = useIntl();
  const primary = env.VITE_PRIMARY_COLOR;

  return (
    <>
      <SlidingPane
        className="custom-sliding-pane"
        overlayClassName={'custom-overlay-sliding-pane-map'}
        title={unit?.unitName}
        isOpen={isSlidingPaneOpen}
        width="35rem"
        onRequestClose={closeSlidingPane}
      >
        {unit.unitImage && (
          <MediaGallery
            height={'20%'}
            heightThumbs={'5%'}
            isRtl={false}
            images={[unit.unitImage]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            navigation={true}
            pagination={true}
            className={'default-width-image'}
            classNameImg={'img-contain-nowidth'}
          />
        )}
        {unit?.latitude != null && unit?.longitude != null && (
          <>
            <Row>
              <Col>
                <Label className="label-information">
                  <MapPin color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                  {intl.formatMessage({ id: 'units.locationName' })}
                </Label>
                <Label className="label-value-information">
                  {!isEmpty(unit.locationName) ? unit.locationName : 'N/A'}
                </Label>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information">
                  <Clock color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                  {intl.formatMessage({ id: 'units.gpsDate' })}
                </Label>
                <Label className="label-value-information">
                  {unit.gpsDate ? moment(unit.gpsDate).format('YYYY-MM-DD HH:mm') : 'N/A'}
                </Label>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information">
                  <Clock color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                  {intl.formatMessage({ id: 'units.lastCommunicationDate' })}
                </Label>
                <Label className="label-value-information">
                  {unit.lastCommunicationDate
                    ? moment(unit.lastCommunicationDate).format('YYYY-MM-DD HH:mm')
                    : 'N/A'}
                </Label>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information">
                  <Icon
                    icon={'Frontier'}
                    color={primary}
                    size={15}
                    style={{ marginRight: '0.2rem' }}
                  />
                  {intl.formatMessage({ id: 'units.odometer' })}
                </Label>
                <Label className="label-value-information">{unit.odometerFormat || 'N/A'} </Label>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information">
                  <Icon
                    icon={'Speedometer'}
                    color={primary}
                    size={17}
                    style={{ marginRight: '0.2rem' }}
                  />
                  {intl.formatMessage({ id: 'units.speed' })}
                </Label>
                <Label className="label-value-information">{unit.speedFormat || 'N/A'}</Label>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information mr-2">
                  <Settings color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                  {intl.formatMessage({ id: 'units.status' })}
                </Label>
                <Badge
                  pill
                  className="mt-25"
                  style={GetMainStateStyle(GetMainStateById(unit?.mainStateId ?? -1))}
                >
                  {GetMainStateName(
                    GetMainStateById(unit?.mainStateId),
                    intl.formatMessage({ id: GetMainStateById(unit.mainStateId).intl }),
                    unit.mainStateDate,
                    unit.speed,
                    unit.downtimeReasonDescription,
                    moment(unit.MainStateDate).fromNow()
                  )}
                </Badge>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information">
                  <Icon
                    icon={'Target'}
                    color={primary}
                    size={15}
                    style={{ marginRight: '0.2rem' }}
                  />
                  {intl.formatMessage({ id: 'units.lastEvent' })}
                </Label>
                <Media id={'lastEventBadge'} className={'d-flex align-items-center'}>
                  {unit?.intlLastEvent?.length >= 15 && (
                    <UncontrolledTooltip target={'lastEventBadge'}>
                      <FormattedMessage id={`organizations.event${unit?.eventId ?? 0}`} />
                    </UncontrolledTooltip>
                  )}
                  <Badge
                    pill
                    className="mt-25 mr-50"
                    style={{
                      color: '#' + (unit.eventTextColor || '000000'),
                      backgroundColor: '#' + unit.eventColor,
                      display: 'inline-block',
                      fontSize: '13px'
                    }}
                  >
                    {unit.eventName || unit.eventId
                      ? `${
                          unit?.intlLastEvent.length >= 15
                            ? unit?.intlLastEvent?.substring(0, 15) + '...'
                            : unit.eventId != null
                            ? unit?.intlLastEvent
                            : ''
                        }`
                      : ''}
                  </Badge>
                </Media>
              </Col>
            </Row>
            <hr className={'full-width-slide-panel'} />
            <Row>
              <Col>
                <Label className="label-information">
                  <Menu color={primary} size={15} style={{ marginRight: '0.2rem' }} />
                  {intl.formatMessage({ id: 'units.privateCode' })}
                </Label>
                <Label className="label-value-information">
                  {!isEmpty(unit.privateCode) ? unit.privateCode : 'N/A'}
                </Label>
              </Col>
            </Row>
          </>
        )}
      </SlidingPane>
    </>
  );
};

export default SlidingPaneSharedLinkUnitInformation;
